import React from "react";
import Carousel from "react-material-ui-carousel";

export default function ReferenceCarousel(props) {
  return <Carousel autoPlay={false}>{props.children}</Carousel>;
}
